import { AxiosAuthHttpClient } from '@prodcard/core'
import { getRequredEnv } from '../common/tools'

export const BASE_URL = getRequredEnv('VUE_APP_BASE_URL')

export const httpClient = new AxiosAuthHttpClient({ baseUrl: BASE_URL })
